const ManualCaptureMessage = () => (
  <>
    <div>
      <h3>Credit/Debit Card Payments via PayMongo</h3>
      <p>
        You can now accept card payments with the option to capture the funds
        later on your Shopify store via PayMongo.
      </p>
      <p>
        Make sure the Hold then Capture card feature is activated for your
        PayMongo account before using manual payment capture on the
        plugin. To request activation, kindly email support@paymongo.com
      </p>
    </div>
    <div>
      <h3>Reminder</h3>
      <ul>
        <li>
          Please be sure that Shopify Onsite Card Checkout is deactivated
          while using this plugin
        </li>
        <li>
          It's ideal to deselect the Credit or Debit Card option in 'Secure
          Payments via PayMongo'. This is so customers only have one option
          for their credit or debit card payments on your Shopify store
        </li>
      </ul>
    </div>
  </>
);

export default ManualCaptureMessage;
